import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
// import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ADD_JILLA_TO_USER = "add-level-to-user";
const REMOVE_JILLA_TO_USER = "remove-level-from-user";

const AdminAddJillaToUser = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
  };
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const userRef = useRef();
  const errRef = useRef();

  const { auth } = useAuth();

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const personId = queryParams.get('person_id');
  const name = queryParams.get('name');
  const mobile = queryParams.get('mobile');
  const [error, setError] = useState(null);
  const [pranthList, setPranthList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState(1);
  const [vibhagList, setVibhagList] = useState([]);
  const [selectedVibhagId, setSelectedVibhagId] = useState("");
  const [jillaList, setJillaList] = useState([]);
  const [selectedJillaId, setSelectedJillaId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const JillasOfJillaUserPerPage = 15;
  const [JillasOfJillaUser, setJillasOfJillaUser] = useState([]);

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);

  useEffect(() => {
    fetchPranthList();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedVibhagId(vibhags[0].vibhag_id);
        } else {
          setSelectedVibhagId("");
          setVibhagList([]);
          setJillaList([]);              // ✅ Add this line
          setSelectedJillaId("");        // ✅ Add this line
          // setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);

  const fetchJilla = useCallback(async () => {
    if (!selectedVibhagId) return;

    // setLoading(true);
    // setJillas([]);
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setJillaList(data);
      if (data.length > 0) {
        setSelectedJillaId(data[0].jilla_id); // optional default
      } else {
        setSelectedJillaId("");
      }
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load Jilla list");
      setJillaList([]);
      setSelectedJillaId("");
    }
    // finally {
    //   setLoading(false);
    // }
  }, [axiosPrivate, selectedVibhagId]);

  useEffect(() => {
    if (selectedVibhagId) {
      fetchJilla();
    }
  }, [selectedVibhagId]);



  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch Vibhag", err);
      setVibhagList([]);
      return [];
    }
  };



  const fetchJillaOfJillaUser = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-levels-of-user?person_id=${personId}`, {
        withCredentials: true,
      });
      setJillasOfJillaUser(response.data);
      // setLoading(false);
    } catch (error) {
      console.error("Error fetching jilla of jilla user:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No jilla of jilla user available.");
      // setLoading(false);
    }
  }, [axiosPrivate, personId]); // 👈 dependency added

  useEffect(() => {
    fetchJillaOfJillaUser();
  }, [personId]);

  const AddJillaToUserSubmit = async (e) => {
    e.preventDefault();

    try {
      var data = JSON.stringify({
        level_id: selectedJillaId,
        person_id: personId,
        role: "Jilla"
      });

      const response = await axiosPrivate.post(ADD_JILLA_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);


      fetchJillaOfJillaUser();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
    }

  };


  const RemoveJillaFromUser = async (e, jillaId, personId) => {
    e.preventDefault();
    try {
      const data = JSON.stringify({
        level_id: jillaId,
        person_id: personId,
        role: "Jilla"
      });
      // console.log("data = ", data)


      const response = await axiosPrivate.post(REMOVE_JILLA_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchJillaOfJillaUser();
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message?.msg || "Unknown error";
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Operation Failed");
      }
    }
  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  const indexOfLastJillasOfJillaUser = currentPage * JillasOfJillaUserPerPage;
  const indexOfFirstJillasOfJillaUser = indexOfLastJillasOfJillaUser - JillasOfJillaUserPerPage;
  const currentJillasOfJillaUser = JillasOfJillaUser.slice(indexOfFirstJillasOfJillaUser, indexOfLastJillasOfJillaUser);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(JillasOfJillaUser.length / JillasOfJillaUserPerPage);

  return (
    <>
      <Container>

        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}


        <section className="userregbody2">

          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>


          <div className="wrapper wrapper2 new_arthiksakha">
            <form>
              <h3 class="arthik_head">Add new Jilla to <span class="colorChange">{name}</span></h3>

              <p className="arthik_head">Phone: {mobile}</p>
              <form onSubmit={AddJillaToUserSubmit}>
                {/* <Form.Label className="newformstyle">Select Pranth</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedPranthId}
                  onChange={(e) => {
                    const pranthId = e.target.value;
                    setSelectedPranthId(pranthId);

                    if (!pranthId) {
                      // Clear vibhag, jilla, and table if no Pranth selected
                      setVibhagList([]);
                      setSelectedVibhagId("");

                      setJillaList([]);
                      setSelectedJillaId("");

                      // setJillas([]);
                    }
                  }}
                > 
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select> */}
                <Row>
                  <Col md={6}>

                    <Form.Label className="newformstyle">Select Vibhag</Form.Label>
                    <Form.Select
                      className="newselectstyle"
                      value={selectedVibhagId}
                      onChange={(e) => {
                        const VibhagId = e.target.value;
                        setSelectedVibhagId(VibhagId);

                        if (!VibhagId) {
                          // Clear Jilla list and selection if no Vibhag selected
                          // setJillaList([]);
                          // setSelectedJillaId("");
                          // setJillas([]); // Optional: clear table too

                          // setJillaList([]);
                          // setSelectedJillaId("");
                          // setJillas([]);
                        }
                      }}
                      disabled={!vibhagList.length}
                    >
                      <option value="">-- Select Vibhag --</option>
                      {Array.isArray(vibhagList) &&
                        vibhagList.map((v) => (
                          <option key={v.vibhag_id} value={v.vibhag_id}>
                            {v.vibhag_name}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>

                  <Col md={6}>

                    <Form.Label className="newformstyle">Select Jilla</Form.Label>
                    <Form.Select
                      className="newselectstyle"
                      value={selectedJillaId}
                      onChange={(e) => setSelectedJillaId(e.target.value)}
                      disabled={!jillaList.length}
                    >
                      <option value="">-- Select Jilla --</option>
                      {jillaList.map((k) => (
                        <option key={k.jilla_id} value={k.jilla_id}>
                          {k.jilla_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>


                </Row>
              </form>



              <button
                type="button" // Important to prevent form submit
                className="btn"
                onClick={AddJillaToUserSubmit} // Call this for "Sign Up"
                disabled={!selectedJillaId}
              >
                Submit
              </button>
            </form>

          </div>

          <br></br>
          <div className="wrapperemp2">
            {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
            <h3>List Jillas of {name}</h3>

            <div className="table-container">
              <table id="customers">
                <thead>
                  <tr>
                    <th>Jilla name (Malayalam)</th>
                    <th>Jilla name</th>
                    <th>Options</th>
                  </tr>
                </thead>

                <tbody>
                  {error ? (
                    <tr>
                      <td colSpan="6" className="text-danger text-center">
                        {error}
                      </td>
                    </tr>
                  ) : JillasOfJillaUser.length === 0 ? (
                    <tr>
                      <td colSpan="6">No Data available.</td>
                    </tr>
                  ) : (
                    currentJillasOfJillaUser.map(JillaOfJillaUser => (
                      <tr key={JillaOfJillaUser.level_id}>
                        <td>{JillaOfJillaUser.level_name}</td>
                        <td>{JillaOfJillaUser.search_tag}</td>


                        <td>
                          <button class="btn btn-danger" onClick={(e) => RemoveJillaFromUser(e, JillaOfJillaUser.level_id, JillaOfJillaUser.person_id)}>
                            Remove Jilla
                          </button>

                        </td>
                      </tr>
                    ))
                  )}
                </tbody>


              </table>
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </section>
        {/* )} */}
      </Container >
    </>
  );
};

export default AdminAddJillaToUser;
